module.exports = __webpack_public_path__ + "img/img_1.2ea9a2cb.png";